module.exports = __webpack_public_path__ + "img/Niue.18de4120.svg";